import React from 'react';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { List } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import SidebarIcon from '../../components/SidebarIcon';
import { Sidebar } from '../../';
import SidebarItemFacility from '../SidebarItemFacility';
import SidebarItemBuilding from '../SidebarItemBuilding';
import { List as immutableList } from 'immutable';
import { Subscribe, appContainer } from '../../../../contexts/app';

// a little function to help us with reordering the result
const reorder = (entities, startIndex, endIndex) => {
  const newEntities = Array.from(entities);
  const [removed] = newEntities.splice(startIndex, 1);
  newEntities.splice(endIndex, 0, removed);

  return newEntities;
};

const getListStyle = isDraggingOver => {
  return isDraggingOver
    ? {
        background: '#d9d9d9',
        borderBottom: '1px solid #d4d4d4',
        borderTop: '1px solid #d4d4d4'
      }
    : {
        borderBottom: '1px solid transparent',
        borderTop: '1px solid transparent'
      };
};

class SidebarEdit extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const { buildingId } = this.props.match.params;
    const buildings = this.props.facility.buildings();
    const curBuilding = buildings.find(building => {
      return building._id === buildingId;
    });
    const floors = curBuilding ? curBuilding.floors() : [];
    this.state = {
      buildings,
      floors
    };
  }
  componentWillReceiveProps(nextProps) {
    const { buildingId } = nextProps.match.params;
    const buildings = nextProps.facility.buildings();
    const curBuilding = buildings.find(building => {
      return building._id === buildingId;
    });
    const floors = curBuilding ? curBuilding.floors() : [];
    this.setState({
      buildings,
      floors
    });
  }
  reorderEntities(draggable) {
    const entityType = [draggable.source.droppableId];
    const entities = this.state[entityType];
    // Place the new order directly in state to create fast experience
    // where the order happens quickly. IG's could be handled
    // totally via props, but because the onOrderChange func is async
    // there is a flash of improper (old) order before the async action
    // completes and returns new order. This is why IG's are maintained
    // in state and via componentWillReceiveProps
    const orderedEntities = immutableList(
      reorder(entities, draggable.source.index, draggable.destination.index)
    );
    this.setState({ [entityType]: orderedEntities });

    // Create the new array of ordered ids to return, which will
    // cause new props and a rerender to the current state.
    const newOrder = orderedEntities.map(ig => ig._id);
    return newOrder;
  }
  onDragEnd(draggable) {
    // dropped outside the list
    if (!draggable.destination) {
      return;
    }
    const entityType = draggable.source.droppableId;
    const reordered = this.reorderEntities(draggable);

    if (entityType === 'buildings') {
      const editedFacility = this.props.facility.set(
        'buildings_order',
        reordered
      );
      editedFacility.patch();
    } else if (entityType === 'floors') {
      const { buildings } = this.state;
      const { buildingId } = this.props.match.params;
      const curBuilding = buildings.find(building => {
        return building._id === buildingId;
      });
      const editedBuilding = curBuilding.set('floors_order', reordered);
      editedBuilding.patch();
    }
  }
  render() {
    const { buildings, floors } = this.state;
    const { facility, match, currentUser } = this.props;
    const { params } = match;
    const { facilityId, buildingId, floorId, path: matchPath } = params;
    const { permissions } = currentUser;
    const listWidth = permissions.edit.resources ? null : 306;
    return (
      <Sidebar>
        {permissions.edit.resources && (
          <div className="icon-wrapper">
            <SidebarIcon match={match} matchFacilityId={facilityId} />
          </div>
        )}
        <div className="list-wrapper">
          <List style={{ padding: 0, width: listWidth }}>
            <SidebarItemFacility
              facility={facility}
              edit={true}
              matchPath={matchPath}
            />
            <Divider />
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="buildings">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {buildings.map((building, index) => {
                      return (
                        <SidebarItemBuilding
                          key={building._id}
                          index={index}
                          facilityId={facilityId}
                          floorId={floorId}
                          edit={true}
                          building={building}
                          floors={floors}
                          selected={buildingId === building._id}
                        />
                      );
                    })}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </List>
        </div>
      </Sidebar>
    );
  }
}

SidebarEdit.propTypes = {
  facility: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default props => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        return (
          <SidebarEdit {...props} currentUser={app.state.get('currentUser')} />
        );
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarMap/Edit/index.jsx